import React from "react";

const SvgOil = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 34 19" ref={svgRef} { ...{ ...{width: "1em", height: "1em"}, ...props } }>
    <title>{title}</title>
    <defs>
      <path
        id="Oil_svg__b"
        d="M1167.267 705l-.427 1.094 5.478 1.858.427-1.094z"
      />
      <path
        id="Oil_svg__c"
        d="M1177.068 715.793c-3.727-.1-4.196-5.593-4.196-5.593l-2.586-.92.404-1.087-3.694-1.316-.404 1.085-2.586-.921-.137.242c-.78-.68-1.869-1.46-2.988-1.865-.887-.32-1.883-.404-2.677.198-.499.381-.853.853-1.043 1.362a2.55 2.55 0 0 0 .18 2.166c.379.672 1.061 1.232 1.997 1.565l.003.002c.8.283 1.588.435 2.29.511l-2.463 4.336 14.775 5.267a763.833 763.833 0 0 0 10.547-3.615c2.89-1.019 4.232-.13 4.232-.13.941-2.533-7.926-1.187-11.654-1.287zm-14.96-5.41a9.38 9.38 0 0 1-2.46-.498c-1.533-.569-1.982-1.665-1.643-2.606.128-.344.371-.68.752-.97.43-.335 1.05-.335 1.817-.065 1.008.353 2.119 1.172 2.848 1.826z"
      />
      <path id="Oil_svg__a" d="M1186.95 718.65h3.413v5.053h-3.413z" />
      <path
        id="Oil_svg__e"
        d="M1188.656 718.65c.318 1.471 1.707 1.71 1.707 3.382 0 .935-.764 1.67-1.707 1.67-.942 0-1.706-.735-1.706-1.67 0-1.672 1.39-1.911 1.706-3.382"
      />
      <clipPath id="Oil_svg__d">
        <use xlinkHref="#Oil_svg__a" />
      </clipPath>
    </defs>
    <use
      fill="currentColor"
      xlinkHref="#Oil_svg__b"
      transform="translate(-1157 -705)"
    />
    <use
      fill="currentColor"
      xlinkHref="#Oil_svg__c"
      transform="translate(-1157 -705)"
    />
    <g clipPath="url(#Oil_svg__d)" transform="translate(-1157 -705)">
      <use fill="currentColor" xlinkHref="#Oil_svg__e" />
    </g>
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => (
  <SvgOil svgRef={ref} {...props} />
));
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/Oil.js